import React from 'react';
import { RouteComponentProps } from '@reach/router';
import { useSelector } from 'react-redux';
// import { Link } from 'gatsby';
import styled from '@emotion/styled';

import { Link18 as Link } from './link';

import { isAuthenticated } from '../../state/selectors/auth';
import { DASHBOARD_URL, LOG_IN_URL, SIGN_UP_URL } from '../../constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  margin: 1em 0;
`;

export default function Lost(_: RouteComponentProps) {
  const loggedIn = useSelector(isAuthenticated);
  return (
    <Container>
      <Link to="/">Return to homepage</Link>
      {loggedIn ? (
        <Link to={DASHBOARD_URL}>Go to dashboard</Link>
      ) : (
        <div>
          <Link to={SIGN_UP_URL}>Sign Up</Link>
          {' or '}
          <Link to={LOG_IN_URL}>Sign In</Link>
        </div>
      )}
    </Container>
  );
}
